interface SessionData {
  words: number;
  segments: number;
  duration: string;
  topics: string[];
}

interface SessionStatsProps {
  stats: SessionData;
}

const SessionStats = ({ stats }: SessionStatsProps) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-lg flex items-center justify-center">
          <i className="ri-bar-chart-box-fill text-white text-sm"></i>
        </div>
        <h3 className="text-lg font-semibold text-slate-900">Session Stats</h3>
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
              <i className="ri-time-fill text-teal-600"></i>
            </div>
            <div>
              <p className="text-xs text-slate-500">Duration</p>
              <p className="text-lg font-semibold text-slate-900">{stats.duration}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <i className="ri-text text-blue-600"></i>
            </div>
            <div>
              <p className="text-xs text-slate-500">Words</p>
              <p className="text-lg font-semibold text-slate-900">{stats.words}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <i className="ri-list-check text-purple-600"></i>
            </div>
            <div>
              <p className="text-xs text-slate-500">Segments</p>
              <p className="text-lg font-semibold text-slate-900">{stats.segments}</p>
            </div>
          </div>
        </div>

        {stats.topics.length > 0 && (
          <div className="pt-4 border-t border-slate-200">
            <p className="text-xs text-slate-500 mb-2">Topics Detected</p>
            <div className="flex flex-wrap gap-2">
              {stats.topics.map((topic, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-gradient-to-r from-teal-50 to-blue-50 text-teal-700 rounded-full text-xs font-medium border border-teal-200"
                >
                  {topic}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SessionStats;